import { AxiosResponse } from 'axios';
import contentDispositionParser from 'content-disposition';

export default class FileHelper {
  static downloadFile(response: AxiosResponse<Blob>) {
    if (response) {
      const parsedContentDisposition = contentDispositionParser.parse(response.request.getResponseHeader('Content-Disposition'));
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', parsedContentDisposition.parameters.filename);
      document.body.appendChild(link);
      link.click();
    }
  }
}
